//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Model from "@/models/yunMobile";
import CarNoInput from "@/components/carNo-input";
export default {
  components: {
    CarNoInput
  },
  data() {
    return {
      carType: "plate",
      balanceList: [],
      formData: {
        carNo: "湘A12345",
        unParkNo: "",
        freeDuration: "",
        busNo: "",
        imageUrl: "",
        inputTime: "",
        stopTime: "",
        disFace: "",
        disNums: "",
        discountType: "",
        receivableMoney: "",
        timestanp: ""
      },
      checkPass: false,
      checkMsg: "",
      rules: {}
    };
  },
  methods: {
    handleDone(value) {
      console.log(value);
    },
    async getDetail() {
      const { carNo, busNo, unParkNo } = this.formData;
      const { freeDuration } = this.$route.params;
      if (this.carType == "plate" && carNo.length < 7) {
        this.$message.error("请输入正确的车牌号码");
        return;
      }
      if (this.carType == "phone" && !/^1[3-9]\d{9}$/.test(carNo)) {
        this.$message.error("请输入正确的手机号码");
        return;
      }
      const { data } = await Model.getCodeDetail({
        chepai: carNo,
        parkNo: unParkNo,
        busNo,
        isNew: true,
        freeDuration: 0
      });

      console.log(data);
      if (data.success) {
        const { list } = data;
        for (let key in this.formData) {
          if (list[key] || list[key] == 0) {
            this.formData[key] = list[key];
          }
        }
      } else {
        this.$message.error(data.error || data.message);
      }
    },
    async checkCode() {
      const { unParkNo, busNo, timestanp } = this.formData;
      const { data } = await Model.checkCode({
        busNo,
        parkNo: unParkNo,
        updateTime: timestanp
      });
      if (data.success) {
        this.checkPass = true;
      } else {
        this.checkMsg = data.error;
      }
    },
    async onSubmit() {
      const {
        unParkNo,
        carNo,
        freeDuration,
        busNo,
        disFace,
        disNums
      } = this.formData;
      if (this.carType == "plate" && carNo.length < 7) {
        this.$message.error("请输入正确的车牌号码");
        return;
      }
      if (this.carType == "phone" && !/^1[3-9]\d{9}$/.test(carNo)) {
        this.$message.error("请输入正确的手机号码");
        return;
      }

      const { data } = await Model.submitCode({
        busNo,
        chepai: carNo,
        parkNo: unParkNo,
        disMoney: disFace,
        number: disNums,
        mianfeiTime: freeDuration == "undefined" ? "" : freeDuration
      });
      if (data.success) {
        this.$router.push("/mobile/yunMobile/resultPay");
      }
      data.success
        ? this.$message.success(data.msg)
        : this.$message.error(data.error);
    }
  },
  created() {
    const { parkNo, busNo, freeDuration, timestanp } = this.$route.params;
    this.formData.unParkNo = parkNo;
    this.formData.busNo = busNo;
    this.formData.timestanp = timestanp;
    this.formData.freeDuration = freeDuration;
    this.checkCode();
  },
  mounted() {
    Model.getUserMoneyByBusNo(this.formData.busNo).then(res => {
        this.balanceList = res.data.list
    });
  },
};



// WEBPACK FOOTER //
// ./src/pages/mobile/yunMobile/ticket.vue